import gql from 'graphql-tag'

export const triggerEventNotification = gql`
  mutation TriggerEventNotification($deviceId: ID!, $eventCode: String!) {
    triggerEventNotification(input: { deviceId: $deviceId, eventCode: $eventCode }) {
      success
      message
      clientMutationId
    }
  }
`
